// extracted by mini-css-extract-plugin
export default {"wrapper":"cursor-module--wrapper--c8b54"};